<!-- ====================== MOBILE TOOLBAR (< 1300px) ====================== -->
<ng-container *ngIf="isMiddle">
    <div class="toolbar">
        <!-- Row 1: Admission button (left) + Social icons (right) -->
        <div class="d-flex flex-nowrap align-items-center justify-content-between mb-1">
            <div class="flex-shrink-0">
                <a *ngIf="!loadingData" routerLink="/admission-details" class="button default-btn-scroll">Click here for
                    admission</a>
                <div *ngIf="loadingData" class="placeholder-glow">
                    <span class="placeholder rounded" style="width: 180px; height: 32px; display: inline-block;"></span>
                </div>
            </div>
            <div class="flex-shrink-0 d-flex">
                <ul class="topbar-social-links-scroll" *ngIf="!loadingData">
                    <li>
                        <a href="https://www.facebook.com/people/CPSC-BUSMS/61550100162572/?ref=embed_page#"
                            target="_blank"><i class="bx bxl-facebook" style="font-size: 26px; color: #ffffff;"></i></a>
                    </li>
                    <li>
                        <a href="https://youtu.be/45ifXVW4RzE?si=QpHsWLS_LjIkNalt" target="_blank"><i
                                class="bx bxl-youtube" style="font-size: 26px; color: #ffffff;"></i></a>
                    </li>
                </ul>
                <ul class="topbar-social-links-scroll placeholder-glow" *ngIf="loadingData"
                    style="display: flex; gap: 8px;">
                    <li><span class="placeholder rounded-circle"
                            style="width: 26px; height: 26px; display: inline-block;"></span></li>
                    <li><span class="placeholder rounded-circle"
                            style="width: 26px; height: 26px; display: inline-block;"></span></li>
                </ul>
            </div>
        </div>
        <!-- Row 2: Notice scroll (full width) -->
        <div class="w-100">
            <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseleave="this.start();">
                <table class="border-0 align-items-center">
                    <tbody class="align-items-center placeholder-glow" *ngIf="loadingData">
                        <tr>
                            <td class="border-0">
                                <span class="placeholder" style="width: 200px; display: inline-block;"></span>
                                &nbsp; &nbsp; &nbsp;
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="align-items-center" *ngIf="!loadingData && Notices.length == 0">
                        <tr>
                            <td class="border-0">
                                <a class="scroll-text">No Notices Found</a>
                                &nbsp; &nbsp; &nbsp;
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="align-items-center" *ngIf="!loadingData && Notices.length != 0">
                        <tr>
                            <td class="border-0" *ngFor="let data of Notices">
                                <a (click)="onNavigate(data.FileLink)" class="scroll-text">{{ data.EnglishTitle }}</a>
                                &nbsp; &nbsp; &nbsp;
                            </td>
                        </tr>
                    </tbody>
                </table>
            </marquee>
        </div>
    </div>
</ng-container>

<!-- ====================== DESKTOP TOOLBAR (>= 1300px) ====================== -->
<ng-container *ngIf="isLeft">
    <div class="toolbar d-flex flex-nowrap align-items-center justify-content-between">
        <!-- Admission Button -->
        <div class="flex-shrink-0">
            <a *ngIf="!loadingData" routerLink="/admission-details" class="button default-btn-scroll">Click here for
                admission</a>
            <div *ngIf="loadingData" class="placeholder-glow">
                <span class="placeholder rounded" style="width: 200px; height: 35px; display: inline-block;"></span>
            </div>
        </div>
        <!-- Notice Marquee -->
        <div class="flex-grow-1 d-flex justify-content-center px-2">
            <div style="width: 80%">
                <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseleave="this.start();">
                    <table class="border-0 align-items-center">
                        <tbody class="align-items-center placeholder-glow" *ngIf="loadingData">
                            <tr>
                                <td class="border-0">
                                    <span class="placeholder" style="width: 200px; display: inline-block;"></span>
                                    &nbsp; &nbsp; &nbsp;
                                </td>
                            </tr>
                        </tbody>
                        <tbody class="align-items-center" *ngIf="!loadingData && Notices.length == 0">
                            <tr>
                                <td class="border-0">
                                    <a class="scroll-text">No Notices Found</a>
                                    &nbsp; &nbsp; &nbsp;
                                </td>
                            </tr>
                        </tbody>
                        <tbody class="align-items-center" *ngIf="!loadingData && Notices.length != 0">
                            <tr>
                                <td class="border-0" *ngFor="let data of Notices">
                                    <a (click)="onNavigate(data.FileLink)" class="scroll-text">{{ data.EnglishTitle
                                        }}</a>
                                    &nbsp; &nbsp; &nbsp;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </marquee>
            </div>
        </div>
        <!-- Social Media Icons -->
        <div class="flex-shrink-0 d-flex justify-content-end">
            <ul class="topbar-social-links-scroll" *ngIf="!loadingData">
                <li>
                    <a href="https://www.facebook.com/people/CPSC-BUSMS/61550100162572/?ref=embed_page#"
                        target="_blank"><i class="bx bxl-facebook" style="font-size: 30px; color: #ffffff;"></i></a>
                </li>
                <li>
                    <a href="https://youtu.be/45ifXVW4RzE?si=QpHsWLS_LjIkNalt" target="_blank"><i class="bx bxl-youtube"
                            style="font-size: 30px; color: #ffffff;"></i></a>
                </li>
            </ul>
            <ul class="topbar-social-links-scroll placeholder-glow" *ngIf="loadingData"
                style="display: flex; gap: 10px; margin: 0; padding: 0; align-items: center;">
                <li><span class="placeholder rounded-circle"
                        style="width: 30px; height: 30px; display: inline-block;"></span></li>
                <li><span class="placeholder rounded-circle"
                        style="width: 30px; height: 30px; display: inline-block;"></span></li>
            </ul>
        </div>
    </div>
</ng-container>

<!-- Topbar Skeleton Large -->
<div aria-hidden="true" *ngIf="loadingData" class="topbar-wrap-area box d-none d-md-block">
    <div class="container-fluid placeholder-glow">
        <div class="row align-items-center justify-content-between" style="min-height: 70px;">
            <div class="col-md-8">
                <span class="placeholder col-6" style="height: 40px; border-radius: 4px;"></span>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center gap-3">
                <span class="placeholder rounded" style="width: 80px; height: 35px;"></span>
                <span class="placeholder rounded" style="width: 80px; height: 35px;"></span>
                <span class="placeholder rounded" style="width: 80px; height: 35px;"></span>
                <span class="placeholder rounded" style="width: 70px; height: 32px;"></span>
            </div>
        </div>
    </div>
</div>

<!-- Topbar Skeleton Small -->
<div aria-hidden="true" *ngIf="loadingData" class="topbar-wrap-area box d-block d-md-none">
    <div class="container-fluid placeholder-glow">
        <div class="row topbar-action-list text-center">
            <div class="col-12 mb-2 mt-2">
                <span class="placeholder col-8" style="height: 35px; border-radius: 4px;"></span>
            </div>
            <div class="col-12 d-flex justify-content-center gap-3 mb-2 align-items-center">
                <span class="placeholder rounded-circle" style="width: 30px; height: 30px;"></span>
                <span class="placeholder rounded-circle" style="width: 30px; height: 30px;"></span>
                <span class="placeholder rounded" style="width: 55px; height: 26px;"></span>
            </div>
        </div>
    </div>
</div>

<!-- Topbar for Large Screen -->
<div class="topbar-wrap-area box d-none d-md-block" *ngIf="!loadingData">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-between">
            <div class="col-md-8">
                <a routerLink="/" routerLinkActive="active" class="nav-link text-start schoolName"
                    style="color: #327ab5; font-size: 35px !important;">
                    {{ mainData.Name }}
                </a>
            </div>
            <div class="col-md-4 d-flex justify-content-end">
                <ul class="topbar-action-list">
                    <li class="navIcon">
                        <a target="_blank"
                            href="https://www.facebook.com/people/CPSC-BUSMS/61550100162572/?ref=embed_page#">
                            <button class="btn old-btn">Facebook</button>
                        </a>
                    </li>
                    <li class="navIcon">
                        <a target="_blank" href="https://mail.google.com/mail/?view=cm&fs=1&to=hmsghs@gmail.com">
                            <i class="fa fa-envelope"></i>
                            <span class="d-none d-md-inline">Email</span>
                        </a>
                    </li>
                    <li class="navIcon">
                        <a routerLink="/contact">
                            <i class="fa fa-address-book"></i>
                            <span class="d-none d-md-inline">Contact Us</span>
                        </a>
                    </li>
                    <li class="navIcon login-item">
                        <a href="https://portal.cloudcampus24.com/" target="_blank" rel="noopener noreferrer"
                            class="button login-btn">
                            Login
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<!-- Topbar for Small Screen -->
<div class="topbar-wrap-area box d-block d-md-none" *ngIf="!loadingData">
    <div class="container-fluid">
        <div class="row topbar-action-list">

            <!-- School Name -->
            <div class="col-12 text-center mb-1">
                <a routerLink="/" routerLinkActive="active" class="nav-link schoolName"
                    style="color: #327ab5; font-size: 30px !important;">
                    {{ mainData.Name }}
                </a>
            </div>

            <!-- Icons below the name -->
            <div class="col-12 d-flex justify-content-center">
                <ul class="topbar-action-list d-flex gap-2 align-items-center">
                    <!-- <li class="navIcon">
      <a target="_blank" href="https://www.facebook.com/sghscdhaka/?ref=embed_page">
        <i class="bx bxl-facebook fa-lg" style="font-size: 30px; color: #4267B2;"></i>
      </a>
    </li>
    <li class="navIcon">
      <a target="_blank" href="https://youtube.com">
        <i class="bx bxl-youtube fa-lg" style="color: #4267B2;"></i>
      </a>
    </li> -->
                    <li class="navIcon">
                        <a target="_blank" href="https://mail.google.com/mail/?view=cm&fs=1&to=hmsghs@gmail.com">
                            <i class="fa fa-envelope fa-lg" style="color: #4267B2;"></i>
                        </a>
                    </li>
                    <li class="navIcon">
                        <a href="/contact">
                            <i class="fa fa-address-book fa-lg" style="color: #327ab5;"></i>
                        </a>
                    </li>
                    <li class="navIcon login-item">
                        <a href="https://portal.cloudcampus24.com/" target="_blank" rel="noopener noreferrer"
                            class="button login-btn">
                            Login
                        </a>
                    </li>
                </ul>
            </div>


        </div>
    </div>
</div>


<!-- Navbar Skeleton -->
<div class="navbar-area navbar-area-with-position-relative" *ngIf="loadingData">
    <div class="karlson-nav">
        <div class="container-fluid placeholder-glow">
            <nav class="navbar navbar-expand-lg navbar-light justify-content-center" style="min-height: 90px;">
                <div class="d-none d-lg-flex w-100 justify-content-center align-items-center gap-4">
                    <span class="placeholder col-1" style="height: 20px;"></span>
                    <span class="placeholder col-1" style="height: 20px;"></span>
                    <span class="placeholder col-1" style="height: 20px;"></span>
                    <span class="placeholder rounded-circle" style="width: 60px; height: 60px;"></span>
                    <span class="placeholder col-1" style="height: 20px;"></span>
                    <span class="placeholder col-1" style="height: 20px;"></span>
                    <span class="placeholder col-1" style="height: 20px;"></span>
                </div>
                <!-- Mobile Navbar Skeleton -->
                <div class="d-flex d-lg-none w-100 justify-content-between align-items-center">
                    <span class="placeholder rounded-circle" style="width: 50px; height: 50px;"></span>
                    <span class="placeholder" style="width: 40px; height: 30px; border-radius: 4px;"></span>
                </div>
            </nav>
        </div>
    </div>
</div>

<div class="navbar-area navbar-area-with-position-relative" *ngIf="!loadingData">
    <div class="karlson-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="d-lg-none">
                    <a class="navbar-brand d-" routerLink="/">
                        <img [src]="mainData.LogoUrl" alt="logo" class="logo img-fluid" />
                    </a>
                </div>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent" *ngIf="isBig">
                    <ul class="navbar-nav">
                        <ng-container *ngFor="let item of array1">
                            <!-- Top-level item with no dropdown -->
                            <ng-container ntainer *ngIf="item.Items.length === 0">
                                <li class="nav-item">
                                    <a [routerLink]="item.MenuUrl" routerLinkActive="active" class="nav-link">{{
                                        item.MenuName }}</a>
                                </li>
                            </ng-container>
                            <!-- Top-level item with dropdown -->
                            <ng-container *ngIf="item.Items.length > 0">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ item.MenuName }}
                                        <i class="fa-solid fa-caret-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let child of item.Items">
                                            <li *ngIf="!child.Items || child.Items.length === 0" class="nav-item"
                                                data-toggle="collapse" data-target=".navbar-collapse.show">
                                                <a href="{{child.MenuUrl}}" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link">{{ child.DisplayName }}</a>
                                            </li>
                                            <li *ngIf="child.Items && child.Items.length > 0"
                                                class="nav-item dropdown dropdown-submenu">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)"
                                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {{ child.DisplayName }}
                                                    <i class="fa-solid fa-caret-right" style="margin-left: 5px;"></i>
                                                </a>
                                                <ul class="dropdown-menu">
                                                    <ng-container *ngFor="let subChild of child.Items">
                                                        <li class="nav-item" data-toggle="collapse"
                                                            data-target=".navbar-collapse.show">
                                                            <a href="{{subChild.MenuUrl}}" routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{ exact: true }"
                                                                class="nav-link">{{ subChild.DisplayName }}</a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                    <div class="d-none d-lg-block mx-lg-4">
                        <a routerLink="/">
                            <img [src]="mainData.LogoUrl" alt="logo" class="logo-image navbar-logo" />
                        </a>
                    </div>
                    <ul class="navbar-nav">
                        <ng-container *ngFor="let item of array2">
                            <!-- Top-level item with no dropdown -->
                            <ng-container ntainer *ngIf="item.Items.length === 0">
                                <li class="nav-item">
                                    <a [routerLink]="item.MenuUrl" routerLinkActive="active" class="nav-link">{{
                                        item.MenuName }}</a>
                                </li>
                            </ng-container>

                            <!-- Top-level item with dropdown -->
                            <ng-container *ngIf="item.Items.length > 0">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ item.MenuName }}
                                        <i class="fa-solid fa-caret-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let child of item.Items">
                                            <li *ngIf="!child.Items || child.Items.length === 0" class="nav-item"
                                                data-toggle="collapse" data-target=".navbar-collapse.show">
                                                <a href="{{child.MenuUrl}}" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link">{{ child.DisplayName }}</a>
                                            </li>
                                            <li *ngIf="child.Items && child.Items.length > 0"
                                                class="nav-item dropdown dropdown-submenu dropdown-submenu-left">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)"
                                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {{ child.DisplayName }}
                                                    <i class="fa-solid fa-caret-right" style="margin-left: 5px;"></i>
                                                </a>
                                                <ul class="dropdown-menu">
                                                    <ng-container *ngFor="let subChild of child.Items">
                                                        <li class="nav-item" data-toggle="collapse"
                                                            data-target=".navbar-collapse.show">
                                                            <a href="{{subChild.MenuUrl}}" routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{ exact: true }"
                                                                class="nav-link">{{ subChild.DisplayName }}</a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
                <div class="collapse navbar-collapse mean-menu-new" id="navbarSupportedContent" *ngIf="isSmall">
                    <ul class="navbar-nav">
                        <ng-container *ngFor="let item of array1">
                            <!-- Top-level item with no dropdown -->
                            <ng-container ntainer *ngIf="item.Items.length === 0">
                                <li class="nav-item">
                                    <a [routerLink]="item.MenuUrl" routerLinkActive="active" class="nav-link">{{
                                        item.MenuName }}</a>
                                </li>
                            </ng-container>
                            <!-- Top-level item with dropdown -->
                            <ng-container *ngIf="item.Items.length > 0">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ item.MenuName }}
                                        <i class="fa-solid fa-caret-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let child of item.Items">
                                            <li *ngIf="!child.Items || child.Items.length === 0" class="nav-item"
                                                data-toggle="collapse" data-target=".navbar-collapse.show">
                                                <a [routerLink]="child.MenuUrl" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link">{{ child.DisplayName }}</a>
                                            </li>
                                            <li *ngIf="child.Items && child.Items.length > 0"
                                                class="nav-item dropdown dropdown-submenu">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)"
                                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {{ child.DisplayName }}
                                                    <i class="fa-solid fa-caret-right" style="margin-left: 5px;"></i>
                                                </a>
                                                <ul class="dropdown-menu">
                                                    <ng-container *ngFor="let subChild of child.Items">
                                                        <li class="nav-item" data-toggle="collapse"
                                                            data-target=".navbar-collapse.show">
                                                            <a href="{{subChild.MenuUrl}}" routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{ exact: true }"
                                                                class="nav-link">{{ subChild.DisplayName }}</a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                        </ng-container>
                        <div class="d-none d-lg-block mx-lg-4">
                            <a routerLink="/">
                                <img [src]="mainData.LogoUrl" alt="logo" class="logo-image navbar-logo" />
                            </a>
                        </div>
                        <ng-container *ngFor="let item of array2">
                            <!-- Top-level item with no dropdown -->
                            <ng-container ntainer *ngIf="item.Items.length === 0">
                                <li class="nav-item">
                                    <a [routerLink]="item.MenuUrl" routerLinkActive="active" class="nav-link">{{
                                        item.MenuName }}</a>
                                </li>
                            </ng-container>

                            <!-- Top-level item with dropdown -->
                            <ng-container *ngIf="item.Items.length > 0">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ item.MenuName }}
                                        <i class="fa-solid fa-caret-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let child of item.Items">
                                            <li *ngIf="!child.Items || child.Items.length === 0" class="nav-item"
                                                data-toggle="collapse" data-target=".navbar-collapse.show">
                                                <a href="{{child.MenuUrl}}" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link">{{ child.DisplayName }}</a>
                                            </li>
                                            <li *ngIf="child.Items && child.Items.length > 0"
                                                class="nav-item dropdown dropdown-submenu dropdown-submenu-left">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)"
                                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {{ child.DisplayName }}
                                                    <i class="fa-solid fa-caret-right" style="margin-left: 5px;"></i>
                                                </a>
                                                <ul class="dropdown-menu">
                                                    <ng-container *ngFor="let subChild of child.Items">
                                                        <li class="nav-item" data-toggle="collapse"
                                                            data-target=".navbar-collapse.show">
                                                            <a href="{{subChild.MenuUrl}}" routerLinkActive="active"
                                                                [routerLinkActiveOptions]="{ exact: true }"
                                                                class="nav-link">{{ subChild.DisplayName }}</a>
                                                        </li>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- Nav Bar Botttom Section Skeleton -->
<div class="d-flex justify-content-around sticky-navbar-bottom box placeholder-glow" *ngIf="loadingData"
    style="min-height: 54px; align-items: center;">
    <span class="placeholder col-2" style="height: 20px; border-radius: 4px;"></span>
    <span class="placeholder col-2" style="height: 20px; border-radius: 4px;"></span>
    <span class="placeholder col-2" style="height: 20px; border-radius: 4px;"></span>
    <span class="placeholder col-2" style="height: 20px; border-radius: 4px;"></span>
</div>

<!-- Nav Bar Botttom Section -->
<div class="d-flex justify-content-around sticky-navbar-bottom box" *ngIf="!loadingData">
    <div class="p-2">
        <a routerLink="/administration/governingBody" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="nav-link">Governing Body</a>
    </div>
    <div class="p-2">
        <a href="administration/message-of-principal" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="nav-link">Principal</a>
    </div>
    <div class="p-2">
        <a href="administration/message-of-vice-principal-college" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="nav-link">Vice Principal</a>
    </div>
    <div class="p-2">
        <a routerLink="/history" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link">History</a>
    </div>
</div>